import * as React from "react";
import { forwardRef } from "react";
const SvgSelected = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, transform: "translate(3 2)" }, /* @__PURE__ */ React.createElement("ellipse", { cx: 9, cy: 4.667, rx: 4.846, ry: 4.667 }), /* @__PURE__ */ React.createElement("path", { d: "M0 20c0-4.786 4.03-8.667 9-8.667s9 3.88 9 8.667" })));
const ForwardRef = forwardRef(SvgSelected);
export { ForwardRef as ReactComponent };
